import { useEffect } from "react";
// Uyarı kutusu tasarımı için Material UI bileşenlerini ekledik
import { Box, Typography } from "@mui/material";

type Props = {
    file: any;
};

export default function PDFViewer({ file }: Props) {

    useEffect(()=> {
    }, [file])

    // --- EKLEME YAPILAN KISIM (BAŞLANGIÇ) ---
    // Eğer dosya adresi yoksa (null veya boş string ise) Iframe yerine bu kutuyu göster.
    if (!file) {
        return (
            <Box 
                sx={{ 
                    width: "100%", 
                    height:"100%",
                    minHeight: "75vh", // Iframe ile aynı yükseklik (Layout bozulmasın diye)
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center",
                    backgroundColor: "#f5f5f5", // Hafif gri arka plan
                    borderRadius: 2,
                    border: "1px dashed #ccc" // Şık görünmesi için kesikli kenarlık
                }}
            >
                <Typography variant="h6" color="text.secondary" align="center">
                    There are only 12-det plots for Bayesian events.
                </Typography>
            </Box>
        );
    }
    // --- EKLEME YAPILAN KISIM (BİTİŞ) ---

    // Değişiklikler (Senin orijinal ayarların):
    // 1. style={{ minHeight: "75vh" }} -> Korundu.
    // 2. view=FitH, toolbar=1, navpanes=0 -> Korundu.
    return (
        <iframe 
            width="100%" 
            height="100%"
            style={{ minHeight: "75vh", border: "none" }} 
            src={`${file}#toolbar=1&navpanes=0&view=FitH`} 
        />
    );
}